import React from 'react';
import { withStyles } from '@material-ui/styles';
import { ButtonOne } from '../ButtonOne/ButtonOne.component';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';

const CancelButton = withStyles(() => ({
  root: {
    width: '135px',
    height: '36px',
    padding: '0px 0px 0px 0px',
    margin: '10px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(ButtonOne);

const ConfirmButton = withStyles(() => ({
  root: {
    width: '135px',
    height: '36px',
    padding: '0px 0px 0px 0px',
    margin: '10px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      color: '#FFFFFF',
      backgroundColor: '#2C2D3E4D',
      border: 'solid 1px #2C2D3E4D',
    },
  },
}))(ButtonOne);

interface ActionButtonsProps {
  activeTreeLevel?: string;
  saveHandle: () => void;
  closeHandle: () => void;
  disable: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = (props) => {
  const { t } = useTranslation();
  return (
    <Grid container justifyContent="flex-end" alignItems="center" style={{ padding: '10px', maxWidth: '350px' }}>
      <CancelButton onClick={props.closeHandle}>Anuluj</CancelButton>
      <ConfirmButton disabled={props.disable} onClick={props.saveHandle}>
        Zapisz
      </ConfirmButton>
    </Grid>
  );
};

export default ActionButtons;
